export { default } from './FinanciamentoDePesados25Blog';
